import Networks from './constants/Networks'

const config = {
    isThetaNetworkLive: true,

    defaultThetaChainID: Networks.THETA_MAINNET,

    faucetAvailable: true,

    isEmbedMode: false,
};

export default config;
